import type { Movimentacao } from '../../models';
import { METODO_ENTREGA_LABELS } from './solicitacaoDetailsPage.definitions';

/** Linhas de resumo das seções da Movimentação (ver LinhaSecaoMovimentacao). */
function dataCurta(valor: Movimentacao['dataEnvio']): string | null {
  if (!valor) return null;
  const data = 'toDate' in valor ? valor.toDate() : new Date(valor as unknown as string);
  return data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}

/** Uma linha do que a logística já tem (método · envio · recebimento). */
export function resumoLogistica(movimentacao: Movimentacao): string {
  const metodo = movimentacao.metodoEntrega ? METODO_ENTREGA_LABELS[movimentacao.metodoEntrega] : 'método a definir';
  const envio = dataCurta(movimentacao.dataEnvio);
  const recebimento = dataCurta(movimentacao.dataRecebimento);
  return [
    metodo,
    movimentacao.codigoRastreio ? `código ${movimentacao.codigoRastreio}` : null,
    envio ? `envio ${envio}` : 'envio a definir',
    recebimento ? `recebimento ${recebimento}` : 'recebimento a definir',
  ]
    .filter(Boolean)
    .join(' · ');
}

export function resumoTermo(movimentacao: Movimentacao): string {
  if (movimentacao.termoAssinado?.url) return 'assinado e anexado';
  if (!movimentacao.termoUrl) return 'não gerado';
  if (movimentacao.etapas.termo !== 'concluido') return 'gerado · falta enviar pra assinatura';
  return 'enviado pra assinatura · falta anexar o assinado';
}
